// @flow

import get from 'lodash/get';
import Service from './service';
import PlanUtils from './utils/plan';

import type { ApiConstructorArgsType } from '../types/api';
import type { VisionEligibilityResponseType, VisionPlanType } from '../types/vision-plan';

export default class VisionPlanService extends Service {
  constructor(args: ApiConstructorArgsType = {}) {
    super(args);
    this.baseUrl = `${this.conf.path.searchBase}/vision/plan`;
  }

  getEligible(appParams: Object, buyDate?: Date): Promise<VisionEligibilityResponseType> {
    const params = { ...PlanUtils.getDateParams(buyDate, 'vision'), ...appParams };

    return this.api.get(`${this.baseUrl}/eligible`, { params, cache: true })
      .then(response => ({
        plans: response.data.map(planMeta => ({
          ...planMeta.plan,
          premiumMonth: planMeta.totalMonthlyPremium.standAlone,
          premiumMonthBundle: planMeta.totalMonthlyPremium.dentalBundle,
        })),
        effectiveDate: get(response, 'data.0.enrollment.effectiveDate', null),
      }));
  }

  getDetails(id: number): Promise<VisionPlanType> {
    return this.api.get(`${this.baseUrl}/${id}`, { cache: true })
      .then(response => ({
        ...response.data.plan,
        benefits: response.data.benefits,
      }));
  }
}
